import { SET_USER_PREFERENCES } from "./userPreferencesTypes";

export const setUserPreferences = (preferences) => ({
  type: SET_USER_PREFERENCES,
  payload: preferences,
});
